module.exports = __webpack_public_path__ + "img/spices.f58b6e1b.jpg";